/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SystemHealthResponse } from '../models/SystemHealthResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SystemService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lightweight system health endpoint. No authentication required.
     * @returns SystemHealthResponse OK
     * @throws ApiError
     */
    public getSystemhealth(): CancelablePromise<SystemHealthResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/systemhealth',
        });
    }
}
